<template lang="pug">
  app-modal(
    titulo="Histórico",
    :width="1000",
    @closeModal="closeModal()"
    :hasFooter="false"
  )
    template(slot="body")
      .modal
        el-row
          p.emptyHistorico(v-if="!historicos || historicos.length === 0") Não há dados.
          el-steps.steps(direction="vertical" :active="activeStep")
            el-step.step(
              v-for="(historico, index) in historicos",
              :key="index"
              :title="configHistorico[historico.tipoHistorico].nome",
              @click.native="changeActive(index)",
              :class="{'inactive-step' : activeStep !== index, 'active-step' : activeStep === index}",
            )
              template(slot="icon")
                p.date-pad {{ getOnlyDate(historico.dataCadastro) }}
                  .circle
              template(slot="description" v-if="activeStep === index")
                .container-informacoes
                  app-par(:chave="configHistorico[historico.tipoHistorico].nome", :valor="getOnlyDateTime(historico.dataCadastro)")
                .container-informacoes
                  app-par(chave="Responsável", :valor="getUsuarioResponsavel(historico)")
                .container-informacoes
                  app-par(chave="Motivo", :valor="historico.observacao")
                .container-informacoes(v-if="historico.tipoHistorico === 'CADASTRADO'")
                  app-par(
                    v-if="perfisAdicionados(historico).length > 0",
                    :chave="perfisAdicionados(historico).length === 1 ? 'Perfil adicionado' : 'Perfis adicionados'",
                    :valor="perfisAdicionadosFormatted(historico)"
                  )
                .container-informacoes(v-if="historico.tipoHistorico === 'ALTERADO'")
                  app-par(
                    v-if="perfisAdicionados(historico).length > 0",
                    :chave="perfisAdicionados(historico).length === 1 ? 'Perfil adicionado' : 'Perfis adicionados'",
                    :valor="perfisAdicionadosFormatted(historico)"
                  )
                  app-par(
                    v-if="perfisExcluidos(historico).length > 0",
                    :chave="perfisExcluidos(historico).length === 1 ? 'Perfil removido' : 'Perfis removidos'",
                    :valor="perfisExcluidosFormatted(historico)")
                .container-informacoes
                  app-download-anexo(v-if="historico.documentoAlteracaoUsuario", :documento="historico.documentoAlteracaoUsuario")
</template>

<script>
import AppModal from '@/components/AppModal'
import { mapActions } from 'vuex'
import AppDownloadAnexo from '@/components/AppDownloadAnexo'
import AppPar from '@/components/AppPar'
import moment from 'moment'

export default {

  components: {
    AppModal,
    AppPar,
    AppDownloadAnexo
  },

  props: {
    idUsuario: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      activeStep: 0,
      configHistorico: {
        BLOQUEADO: {
          nome: 'Bloqueio de usuário'
        },
        DESBLOQUEADO: {
          nome: 'Desbloqueio de usuário'
        },
        CADASTRADO: {
          nome: 'Cadastro de usuário'
        },
        ALTERADO: {
          nome: 'Edição de perfil'
        },
        EDITADO: {
          nome: 'Ediçao de perfil'
        }
      },
      historicos: []
    }
  },

  async created () {
    this.historicos = await this.findHistorico(this.idUsuario)
    this.activeStep = this.historicos.length - 1
  },

  methods: {
    ...mapActions({
      findHistorico: 'usuario/findHistorico'
    }),

    closeModal () {
      this.$emit('closeModal')
    },
    changeActive (stepIndex) {
      this.activeStep = stepIndex
    },

    getOnlyDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },

    getOnlyDateTime (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },

    getUsuarioResponsavel (historico) {
      return historico.usuarioResponsavel !== null ? historico.usuarioResponsavel.pessoa.pessoaFisica.nome : '-'
    },

    perfisExcluidos (historico) {
      return historico.alteracaoPerfil.filter(rel => rel.perfilRemovido !== null)
    },

    perfisExcluidosFormatted (historico) {
      return this.formatPerfisRemovidos(this.perfisExcluidos(historico))
    },

    perfisAdicionados (historico) {
      return historico.alteracaoPerfil.filter(rel => rel.perfilAdicionado !== null)
    },

    perfisAdicionadosFormatted (historico) {
      return this.formatPerfisAdicionados(this.perfisAdicionados(historico))
    },

    formatPerfisAdicionados (relPerfis) {
      const isLast = index => relPerfis.length - 1 === index
      return relPerfis.map(rel => rel.perfilAdicionado.nome).reduce((acm, current, index) => `${acm} ${current}${isLast(index) ? '' : ', '}`, '')
    },

    formatPerfisRemovidos (relPerfis) {
      const isLast = index => relPerfis.length - 1 === index
      return relPerfis.map(rel => rel.perfilRemovido.nome).reduce((acm, current, index) => `${acm} ${current}${isLast(index) ? '' : ', '}`, '')
    }

  }

}

</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.emptyHistorico {
  display: flex;
  justify-content: center;
}

.el-steps {
  p {
    margin: 0;
  }
  .el-step:hover {
    /deep/.el-step.is-vertical {
      .el-step__line {
        background-color: $color-primary;
        border-color: $color-primary;
      }
      .el-step__icon.is-text {
        border-color: $color-primary;
        color: $color-primary;
      }
      .el-step__icon-inner {
        color: $color-primary;
      }
      .el-step__title {
        color: $color-primary;
      }
    }

    .date-pad {
      color: $color-primary;
    }

    .circle {
      background: $color-primary;
    }
  }
}

  /deep/ .el-step__icon.is-text {
    border: none;
    width: 100%;
  }

  /deep/ .el-step__title.is-process {
    color: $color-primary;
  }

  /deep/ .el-step__title.is-wait,
  /deep/ .el-step__head.is-wait,
  /deep/ .el-step__title.is-finish,
  /deep/ .el-step__head.is-finish {
    color: black;
    border-color: black;
    opacity: .7;
  }

  /deep/ .el-step__head.is-wait, /deep/ .el-step__head.is-finish {
    color: black;
    .el-step__line {
      background-color: black;
    }
  }

  /deep/ .el-step__head.is-process {
    color: $color-primary;
    font-weight: bold;
    .circle {
      background: $color-primary;
    }
    .el-step__line {
      background-color: $color-primary;
    }
    .el-step__icon.is-text {
      border-color: $color-primary;
    }
    .date-pad {
      color: $color-primary;
    }
  }

  /deep/ .el-step.is-vertical .el-step__line {
    left: 148px;
    margin-top: 5px;
  }

  /deep/ .el-step__description {
    margin-top: 10px !important;
    padding-left: 30px
  }

  .inactive-step {
    flex-basis: 7% !important;
  }

  .active-step {
    flex-basis: unset !important;
  }

  /deep/ .el-step__head {
    cursor: pointer;
    width: 20% !important;
  }

  /deep/ .el-step__main {
    width: 80% !important;
    padding-left: 20px !important;
    padding-bottom: 10px;
    .el-step__title {
      cursor: pointer;
    }
  }

  .modal {
    height: 71vh;
  }

  .descricao {
    font-size: 13px;
  }

  .steps {
    padding: 20px;
  }

  .painel-historico {
    max-height: 65vh;
    overflow-y: auto;
  }

  .btn-baixar-pdf {
    float: right;
    padding: 13px 30px;
    font-size: 15px;
    margin-top: 15px;
    margin-right: 25px;
    margin-bottom: 15px;
  }
  .margin-left {
    margin-left: 5px;
  }

  .circle {
    border: black;
    border-radius: 50%;
    background: black;
    width: 16px;
    height: 16px;
  }

  .date-pad {
    padding-right: 25px;
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/seguranca/components/AppModalHistoricoAlteracaoUsuario.vue